/**
 * Possible errors when launching OneSchema
 */
var OneSchemaLaunchError;
(function (OneSchemaLaunchError) {
    OneSchemaLaunchError[OneSchemaLaunchError["MissingTemplate"] = 0] = "MissingTemplate";
    OneSchemaLaunchError[OneSchemaLaunchError["MissingJwt"] = 1] = "MissingJwt";
    OneSchemaLaunchError[OneSchemaLaunchError["MissingSessionToken"] = 2] = "MissingSessionToken";
    OneSchemaLaunchError[OneSchemaLaunchError["LaunchError"] = 3] = "LaunchError";
})(OneSchemaLaunchError || (OneSchemaLaunchError = {}));
/**
 * The default values for the OneSchema importer
 */
const DEFAULT_PARAMS = {
    baseUrl: "https://embed.oneschema.co",
    devMode: !!(process.env.NODE_ENV !== "production"),
    className: "oneschema-iframe",
    autoClose: true,
    manageDOM: true,
    saveSession: true,
};
var OneSchemaErrorSeverity;
(function (OneSchemaErrorSeverity) {
    OneSchemaErrorSeverity["Error"] = "error";
    OneSchemaErrorSeverity["Fatal"] = "fatal";
})(OneSchemaErrorSeverity || (OneSchemaErrorSeverity = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

var eventemitter3 = {exports: {}};

(function (module) {

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	{
	  module.exports = EventEmitter;
	}
} (eventemitter3));

var version = "0.7.2";

/**
 * Given an object, return a new object with all entries with `undefined` values
 * removed.
 */
function stripUndefined(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry) => entry[1] !== undefined));
}
/**
 * Given two objects, return a new object with all entries from both objects,
 * skipping any entries with `undefined` values.
 */
function merged(obj1, obj2) {
    return Object.assign(Object.assign({}, stripUndefined(obj1 !== null && obj1 !== void 0 ? obj1 : {})), stripUndefined(obj2 !== null && obj2 !== void 0 ? obj2 : {}));
}

var _OneSchemaImporterClass_instances, _a, _OneSchemaImporterClass_params, _OneSchemaImporterClass_client, _OneSchemaImporterClass_version, _OneSchemaImporterClass_resumeTokenKey, _OneSchemaImporterClass_hasLaunched, _OneSchemaImporterClass_hasCancelled, _OneSchemaImporterClass_initMessage, _OneSchemaImporterClass_hasAppReceivedInitMessage, _OneSchemaImporterClass_iframeIsLoaded, _OneSchemaImporterClass_iframeEventEmit, _OneSchemaImporterClass_hide, _OneSchemaImporterClass_show, _OneSchemaImporterClass_iframeEventListener;
const MAX_LAUNCH_RETRY = 10;
const IMPORTER_EMBED_MARKER = "importer.oneschema.co";
/**
 * OneSchemaImporter class manages the iframe used for importing data in your
 * application and emits events based on what happens.
 */
class OneSchemaImporterClass extends eventemitter3.exports.EventEmitter {
    constructor(params) {
        super();
        _OneSchemaImporterClass_instances.add(this);
        _OneSchemaImporterClass_params.set(this, void 0);
        _OneSchemaImporterClass_client.set(this, "Importer");
        _OneSchemaImporterClass_version.set(this, version);
        _OneSchemaImporterClass_resumeTokenKey.set(this, "");
        this._hasAttemptedLaunch = false;
        _OneSchemaImporterClass_hasLaunched.set(this, false);
        _OneSchemaImporterClass_hasCancelled.set(this, false);
        _OneSchemaImporterClass_initMessage.set(this, void 0);
        _OneSchemaImporterClass_hasAppReceivedInitMessage.set(this, false);
        __classPrivateFieldSet(this, _OneSchemaImporterClass_params, merged(DEFAULT_PARAMS, params), "f");
        // Limit usage to browser only.
        if (typeof window === "undefined") {
            return;
        }
        window.addEventListener("message", __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_iframeEventListener).bind(this));
        if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").manageDOM) {
            const iframeId = "_oneschema-iframe";
            this.iframe = document.getElementById(iframeId);
            if (this.iframe) {
                this.iframe.dataset.count = `${parseInt(this.iframe.dataset.count || "0") + 1}`;
            }
            else {
                const iframe = document.createElement("iframe");
                iframe.id = iframeId;
                iframe.dataset.count = "1";
                this.setIframe(iframe);
            }
            let parent = document.body;
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").parentId) {
                parent = document.getElementById(__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").parentId) || parent;
            }
            this.setParent(parent);
        }
    }
    /**
     * Set the name and version of the client, used for logging/debugging
     * @param client
     * @param version
     */
    setClient(client, version) {
        __classPrivateFieldSet(this, _OneSchemaImporterClass_client, client, "f");
        __classPrivateFieldSet(this, _OneSchemaImporterClass_version, version, "f");
    }
    /**
     * Set the iframe to be used by the OneSchema importer
     * Should only be used in conjunction with the param of manageDOM false
     * @param iframe
     */
    setIframe(iframe) {
        // just in case..
        if (this.iframe) {
            this.close(true);
        }
        this.iframe = iframe;
        this.iframe.setAttribute("allowtransparency", "true");
        const queryParams = [];
        queryParams.push(`embed_client_id=${__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").clientId}`);
        queryParams.push(`dev_mode=${__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").devMode}`);
        if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").languageCode) {
            queryParams.push(`lng=${__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").languageCode}`);
        }
        this.iframe.src = `${__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").baseUrl}/embed-launcher?${queryParams.join("&")}`;
        this.setClassName(__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").className || "");
        if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").styles) {
            this.setStyles(__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").styles);
        }
        __classPrivateFieldSet(OneSchemaImporterClass, _a, false, "f", _OneSchemaImporterClass_iframeIsLoaded);
        this.iframe.onload = () => {
            __classPrivateFieldSet(OneSchemaImporterClass, _a, true, "f", _OneSchemaImporterClass_iframeIsLoaded);
        };
        __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_hide).call(this);
    }
    /**
     * Will change the CSS class of the iframe.
     *
     * @param className the new CSS class
     */
    setClassName(className) {
        if (this.iframe) {
            this.iframe.className = className;
        }
    }
    /**
     * Will change the styles of the iframe.
     *
     * @param styles the styles to apply
     */
    setStyles(styles) {
        if (this.iframe) {
            // we save display because we use it for whether
            // the iframe is shown or not
            const display = this.iframe.style.display;
            Object.assign(this.iframe.style, styles);
            this.iframe.style.display = display;
        }
    }
    /**
     * Will change the parent container of the iframe
     * NOTE: will reload the URL
     * @param parent DOM element to append to
     */
    setParent(parent) {
        if (this.iframe) {
            parent.append(this.iframe);
        }
    }
    /**
     * Launch will show the OneSchema window and initialize the importer session
     * @param launchParams optionally pass in parameter overrides or values not passed into constructor
     */
    launch(launchParams) {
        this._hasAttemptedLaunch = true;
        const mergedParams = merged(__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f"), launchParams);
        const baseMessage = {
            version: __classPrivateFieldGet(this, _OneSchemaImporterClass_version, "f"),
            client: __classPrivateFieldGet(this, _OneSchemaImporterClass_client, "f"),
            manualClose: true,
        };
        let message;
        if (mergedParams.sessionToken) {
            message = Object.assign(Object.assign({}, baseMessage), { messageType: "init-session", sessionToken: mergedParams.sessionToken });
        }
        else {
            message = Object.assign(Object.assign({}, baseMessage), { messageType: "init", userJwt: mergedParams.userJwt, templateKey: mergedParams.templateKey, importConfig: mergedParams.importConfig, customizationKey: mergedParams.customizationKey, customizationOverrides: mergedParams.customizationOverrides, templateOverrides: mergedParams.templateOverrides, eventWebhookKeys: mergedParams.eventWebhookKeys });
            if (!message.userJwt) {
                console.error("OneSchema config error: missing userJwt");
                this.emit("launched", {
                    success: false,
                    error: OneSchemaLaunchError.MissingJwt,
                });
                return { success: false, error: OneSchemaLaunchError.MissingJwt };
            }
            if (!message.templateKey) {
                console.error("OneSchema config error: missing templateKey");
                this.emit("launched", {
                    success: false,
                    error: OneSchemaLaunchError.MissingTemplate,
                });
                return { success: false, error: OneSchemaLaunchError.MissingTemplate };
            }
            if (mergedParams.saveSession) {
                try {
                    __classPrivateFieldSet(this, _OneSchemaImporterClass_resumeTokenKey, `OneSchema-session-${mergedParams.userJwt}-${mergedParams.templateKey}`, "f");
                    const resumeToken = window.localStorage.getItem(__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f"));
                    if (resumeToken) {
                        message.resumeToken = resumeToken;
                    }
                }
                catch (_b) {
                    /* local storage is not available, don't sweat it */
                }
            }
        }
        if (mergedParams.importConfig &&
            mergedParams.importConfig.type === "file-upload" &&
            !mergedParams.importConfig.format) {
            mergedParams.importConfig.format = "csv";
        }
        __classPrivateFieldSet(this, _OneSchemaImporterClass_initMessage, message, "f");
        this._launch();
        return { success: true };
    }
    /**
     * DEPRECATED: use `launch` instead.
     * Launch session will show the OneSchema window and initialize the importer session with the given session token
     * @param launchParams optionally pass in parameter overrides or values not passed into constructor
     */
    launchSession(launchParams) {
        return this.launch(launchParams);
    }
    _launch() {
        const postInit = () => {
            __classPrivateFieldSet(this, _OneSchemaImporterClass_hasCancelled, false, "f");
            this._initWithRetry();
            __classPrivateFieldSet(OneSchemaImporterClass, _a, true, "f", _OneSchemaImporterClass_iframeIsLoaded);
        };
        if (__classPrivateFieldGet(OneSchemaImporterClass, _a, "f", _OneSchemaImporterClass_iframeIsLoaded)) {
            postInit();
        }
        else if (this.iframe) {
            this.iframe.onload = postInit;
        }
    }
    _initWithRetry(count = 1) {
        if (__classPrivateFieldGet(this, _OneSchemaImporterClass_hasLaunched, "f") || __classPrivateFieldGet(this, _OneSchemaImporterClass_hasCancelled, "f") || __classPrivateFieldGet(this, _OneSchemaImporterClass_hasAppReceivedInitMessage, "f")) {
            return;
        }
        if (count > MAX_LAUNCH_RETRY) {
            const msg = "OneSchema failed to respond for initialization";
            console.error(msg);
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").devMode) {
                // Display the iframe for debugging purposes.
                __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_show).call(this);
            }
            else {
                this.emitErrorEvent({
                    message: msg,
                    severity: OneSchemaErrorSeverity.Fatal,
                });
                if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").autoClose) {
                    this.close();
                }
            }
            return;
        }
        __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_iframeEventEmit).call(this, __classPrivateFieldGet(this, _OneSchemaImporterClass_initMessage, "f") || {});
        setTimeout(() => this._initWithRetry(count + 1), 500);
    }
    _resetSession(launchParams) {
        if (__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f")) {
            try {
                window.localStorage.removeItem(__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f"));
            }
            catch (_b) {
                /* local storage is not available, don't sweat it */
            }
        }
        this.close();
        setTimeout(() => {
            this.launch(launchParams);
        });
    }
    /**
     * Close will stop the importing session and hide the OneSchema window
     * @param clean will remove the iframe and event listeners if true
     */
    close(clean) {
        __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_hide).call(this);
        if (this.iframe && __classPrivateFieldGet(OneSchemaImporterClass, _a, "f", _OneSchemaImporterClass_iframeIsLoaded)) {
            __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_iframeEventEmit).call(this, { messageType: "close" });
        }
        this._hasAttemptedLaunch = false;
        __classPrivateFieldSet(this, _OneSchemaImporterClass_hasAppReceivedInitMessage, false, "f");
        __classPrivateFieldSet(this, _OneSchemaImporterClass_hasLaunched, false, "f");
        __classPrivateFieldSet(this, _OneSchemaImporterClass_hasCancelled, true, "f");
        if (clean && this.iframe) {
            if (!this.iframe.dataset.count || this.iframe.dataset.count === "1") {
                this.removeAllListeners();
                window.removeEventListener("message", __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_iframeEventListener));
                if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").manageDOM) {
                    this.iframe.remove();
                }
            }
            else {
                this.iframe.dataset.count = `${parseInt(this.iframe.dataset.count || "1") - 1}`;
            }
        }
    }
    emitErrorEvent(error) {
        this.emit("error", error);
    }
}
_a = OneSchemaImporterClass, _OneSchemaImporterClass_params = new WeakMap(), _OneSchemaImporterClass_client = new WeakMap(), _OneSchemaImporterClass_version = new WeakMap(), _OneSchemaImporterClass_resumeTokenKey = new WeakMap(), _OneSchemaImporterClass_hasLaunched = new WeakMap(), _OneSchemaImporterClass_hasCancelled = new WeakMap(), _OneSchemaImporterClass_initMessage = new WeakMap(), _OneSchemaImporterClass_hasAppReceivedInitMessage = new WeakMap(), _OneSchemaImporterClass_instances = new WeakSet(), _OneSchemaImporterClass_iframeEventEmit = function _OneSchemaImporterClass_iframeEventEmit(message) {
    var _b, _c;
    (_c = (_b = this.iframe) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 ? void 0 : _c.postMessage(Object.assign({ version: __classPrivateFieldGet(this, _OneSchemaImporterClass_version, "f"), client: __classPrivateFieldGet(this, _OneSchemaImporterClass_client, "f"), "@from": `${__classPrivateFieldGet(this, _OneSchemaImporterClass_client, "f")}#${__classPrivateFieldGet(this, _OneSchemaImporterClass_version, "f")}`, "@to": IMPORTER_EMBED_MARKER }, message), __classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").baseUrl);
}, _OneSchemaImporterClass_hide = function _OneSchemaImporterClass_hide() {
    if (this.iframe) {
        this.iframe.style.display = "none";
    }
}, _OneSchemaImporterClass_show = function _OneSchemaImporterClass_show() {
    if (this.iframe) {
        this.iframe.style.display = "initial";
    }
}, _OneSchemaImporterClass_iframeEventListener = function _OneSchemaImporterClass_iframeEventListener({ source, data }) {
    var _b, _c, _d;
    if (source !== ((_b = this.iframe) === null || _b === void 0 ? void 0 : _b.contentWindow)) {
        return;
    }
    switch (data.messageType) {
        case "page-loaded": {
            this.emit("page-loaded", {});
            return;
        }
        // spell-checker: disable
        // NOTE: Was misspelled as "init-recieved" in older versions.
        // spell-checker: enable
        // The correct spelling added in 2024-10.
        case "init-received": {
            __classPrivateFieldSet(this, _OneSchemaImporterClass_hasAppReceivedInitMessage, true, "f");
            return;
        }
        case "launched": {
            __classPrivateFieldSet(this, _OneSchemaImporterClass_hasLaunched, true, "f");
            let sessionToken = data.sessionToken;
            const embedId = data.embedId;
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f") && sessionToken) {
                try {
                    window.localStorage.setItem(__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f"), sessionToken);
                }
                catch (_e) {
                    /* local storage is not available, don't sweat it */
                }
            }
            // if sessionToken is undefined, then we init with one
            // and want to echo it back out
            if (!sessionToken) {
                sessionToken =
                    ((_c = __classPrivateFieldGet(this, _OneSchemaImporterClass_initMessage, "f")) === null || _c === void 0 ? void 0 : _c.resumeToken) ||
                        ((_d = __classPrivateFieldGet(this, _OneSchemaImporterClass_initMessage, "f")) === null || _d === void 0 ? void 0 : _d.sessionToken);
            }
            this.emit("launched", {
                success: true,
                sessionToken,
                embedId,
            });
            __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_show).call(this);
            return;
        }
        case "launch-error": {
            this.emit("launched", {
                success: false,
                error: OneSchemaLaunchError.LaunchError,
            });
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").devMode) {
                __classPrivateFieldGet(this, _OneSchemaImporterClass_instances, "m", _OneSchemaImporterClass_show).call(this);
            }
            else if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").autoClose) {
                this.close();
            }
            return;
        }
        case "complete": {
            if (data.data) {
                // for frontend pass through
                this.emit("success", data.data);
            }
            else {
                // for webhook imports, eventId and responses are used
                this.emit("success", {
                    eventId: data.eventId,
                    responses: data.responses,
                });
            }
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f")) {
                try {
                    window.localStorage.removeItem(__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f"));
                }
                catch (_f) {
                    /* local storage is not available, don't sweat it */
                }
            }
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").autoClose) {
                this.close();
            }
            return;
        }
        case "cancel": {
            this.emit("cancel");
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f")) {
                try {
                    window.localStorage.removeItem(__classPrivateFieldGet(this, _OneSchemaImporterClass_resumeTokenKey, "f"));
                }
                catch (_g) {
                    /* local storage is not available, don't sweat it */
                }
            }
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").autoClose) {
                this.close();
            }
            return;
        }
        case "reset-embed": {
            this._resetSession(data.embedSessionConfig);
            return;
        }
        case "error": {
            this.emitErrorEvent({
                message: data.message,
                severity: OneSchemaErrorSeverity.Fatal,
            });
            if (__classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").autoClose) {
                this.close();
            }
            return;
        }
        // This is temporary and will be removed when we revamp errors.
        case "nonclosing-error": {
            this.emitErrorEvent({
                message: data.message,
                severity: OneSchemaErrorSeverity.Error,
            });
            return;
        }
        case "error-v2": {
            const severity = data.severity || OneSchemaErrorSeverity.Error;
            this.emitErrorEvent({
                message: data.message,
                severity,
            });
            if (severity === OneSchemaErrorSeverity.Fatal && __classPrivateFieldGet(this, _OneSchemaImporterClass_params, "f").autoClose) {
                this.close();
            }
            return;
        }
    }
};
_OneSchemaImporterClass_iframeIsLoaded = { value: false };
/**
 * @param params the settings for the importing session
 * @returns an instance of the OneSchemaImporter
 */
function oneSchemaImporter(params) {
    return new OneSchemaImporterClass(params);
}

export { DEFAULT_PARAMS, OneSchemaErrorSeverity, OneSchemaImporterClass, OneSchemaLaunchError, oneSchemaImporter as default };
//# sourceMappingURL=module.js.map
